import React from 'react';
import moment from 'moment';

import { Card } from 'react-bootstrap';
import { Chart, Grid, CommonSeriesSettings, Series, Export, ArgumentAxis, Legend, Tooltip, Label } from 'devextreme-react/chart';

import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { exportData, renderFullScreen } from '../helpers/utils';

const axisTitles = [
    { value: 'cost', name: 'Monthly Spending' },
];

class lineChartCosting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: '',
            getData: ''
        };
        window.lineChartHistoricUsers = this;
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => { //Adjust in regard to start date and end date
      let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Costing/GetCostByEntity", global.config.dashboard.range, null, null, null)
        let data = []
        if(resp) {
          resp.forEach(element => {
            let date = moment(element.reportDate).format("DD/MM/YYYY")
            data.push({reportDate: date, cost: element.cost})
          });
          this.setState({dataSource: data})
        }
    }

  render() {
    if(this.state.getData !== null) {
      return (
        <Card className="rounded-4">
            <Card.Body>
            <Card.Title>
                  Azure Monthly Costing
                  <div className='float-end'>
                    <span className="fullscreen-link" onClick={() => {renderFullScreen("#lineChartCosting")}}>Full Screen</span>
                      <span> | </span>
                    <span className="fullscreen-link" onClick={() => {exportData("CostingMonthly", this.state.dataSource)}}>Export</span>
                </div>
            </Card.Title>
            <Card.Subtitle>
              Total historic billable Azure Cost by month (excl. current month)
            </Card.Subtitle>
            <Chart
              id="lineChartCosting"
              palette="Violet"
              dataSource={this.state.dataSource}
              title={"Monthly Costing"}
            >
              <CommonSeriesSettings
                argumentField="reportDate"
                type="line"
              />
              {
                axisTitles.map((item) => <Series
                  key={item.value}
                  valueField={item.value}
                  name={item.name} />)
              }
              <Tooltip
                  enabled={true}
                  location="edge"
                  customizeTooltip={this.customizeTooltip}
                  zIndex={10000}
              />
              <ArgumentAxis
                valueMarginsEnabled={false}
                discreteAxisDivisionMode="crossLabels"
              >
                <Label
                  wordWrap="break"
                  overlappingBehavior={"rotate"}
                />
                <Grid visible={true} />
              </ArgumentAxis>
              <Legend
                visible={false}
              />
              <Export enabled={true} />
            </Chart>
          </Card.Body>
        </Card>
      );
    }
  }

  customizeTooltip(arg) {
      let currency = parseFloat(arg.valueText).toLocaleString('en-US', {
        style: 'currency',
        currency: 'GBP',
      });

      return {
          text: `${arg.argumentText} \n Total: ${currency}`,
      }
    }
}

export default lineChartCosting;
